



















































import Vue from "vue";
import store from "./store";

export default Vue.extend({
  name: "App",

  data: () => ({
    isLoading: false,
    loadingValue: 0
  }),

  async mounted() {
    this.$data.isLoading = true;

    await Promise.all([
      store.dispatch("virusCasesFinland/fetchData"),
      store.dispatch("virusCasesFinland/fetchHcdTestData"),
      store.dispatch("virusCasesFinland/fetchThlTestData")
    ]);

    this.$data.loadingValue = 75;

    setTimeout(() => {
      store.dispatch("virusCasesGlobal/fetchData").then(() => {
        this.$data.loadingValue = 100;
        this.$data.isLoading = false;
      });
    }, 1000);
  }
});
